import React, { Component } from "react";
import { formValueSelector, Field, change } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";

import { getMainWindowColours } from "../../selectors/index.js";

import { getWindowOptions } from "actions";
import Loading from "components/Loading";

// import ReactCSSTransitionReplace from 'react-css-transition-replace';
import Popup from "components/Popup";
import ChipsGrid from "../../components/ChipsGrid";
import WhiteInteriorPopup from "../../components/WhiteInteriorPopup";
import ImageResolver from "../ImageResolver";
import FormHeader from "../../components/FormHeader";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormWrapper from "../FormWrapper";
import SwitchInput from "../../components/SwitchInput";
import utils from "../../utils";
import { updatePreviousSelection } from '../../actions';

class SelectColour extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCategory: 1
        };
    }

    render() {
        let { colours, input } = this.props;

        if (colours.length === 0) {
            return <Loading />;
        }
        let filteredColours = colours.filter(colour => colour.category === this.state.selectedCategory);

        return (
            <div>
                <Row collapseOnSmall uncollapseOnMedium>
                    <Column small={12}>
                        <span
                            className={"colour-type-label" + (this.state.selectedCategory === 1
                                ? " selected"
                                : "")}
                            onClick={() => this.setState({ selectedCategory: 1 })}>
                            Standard<span>£</span>
                        </span>

                        <span
                            className={"colour-type-label" + (this.state.selectedCategory === 2
                                ? " selected"
                                : "")}
                            onClick={() => this.setState({ selectedCategory: 2 })}>
                            Special<span>££</span>
                        </span>

                        <span
                            className={"colour-type-label" + (this.state.selectedCategory === 3
                                ? " selected"
                                : "")}
                            onClick={() => this.setState({ selectedCategory: 3 })}>
                            Premium<span>£££</span>
                        </span>
                    </Column>
                </Row>
                <Row isColumn>
                    <ChipsGrid
                        key={this.state.selectedCategory}
                        colours={filteredColours}
                        selectedId={input.value}
                        onChange={input.onChange} />
                </Row>

                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class ColourForm extends Component {
    componentDidMount() {
        this.props.getWindowOptions(this.props.windowStyleId, this.props.windowRoomId);
    }

    componentDidUpdate() {
        let { defaultColourId, selectedColour, colours, dispatch, previousSelection } = this.props;

        if (!selectedColour.id) {
            if (colours.length > 0) {
                // do something
                dispatch(change("WindowWizard", "WindowColourId", previousSelection.WindowColourId || defaultColourId));
                if (previousSelection.WindowColourWhiteInterior)
                    dispatch(change("WindowWizard", "WindowColourInterior", previousSelection.WindowColourWhiteInterior));
            }
        }
    }

    onSubmit(values) {

        if (values.WindowColourId !== this.props.previousSelection.WindowColourId) {
            this.props.updatePreviousSelection({
                WindowHandleColour: null,
                WindowHandleType: null
            });
        }

        this.props.updatePreviousSelection({
            WindowColourId: values.WindowColourId,
            WindowColourWhiteInterior: values.WindowColourInterior
        });

        this.props.onSubmit(values);
    }

    componentWillUpdate(newProps){
        let {hasWhiteInterior, dispatch} = this.props;

        if(!newProps.hasWhiteInterior && hasWhiteInterior){
            dispatch(change("WindowWizard", "WindowColourInterior", false));

        }
    }

    render() {
        let {
            selectedColour,
            handleSubmit,
            colours,
            windowColourInterior,
            hasWhiteInterior
        } = this.props;

        let colourIdFilter = selectedColour.id;

        if (windowColourInterior && selectedColour.relatedColourId) {
            colourIdFilter = selectedColour.relatedColourId;
        }
        return (
            <form className="ColourForm" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader
                    title={"Colour & finish"}
                    subtitle={"We can supply a wide range of finish colours and textures"} />

                <SeparatingLine />

                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column pushOnLarge={7} large={5} className="preview-container">
                            <ImageResolver
                                query={{
                                    productId: this.props.windowStyleId,
                                    extraGroupId: 0
                                }}
                                filters={{
                                    colourId: colourIdFilter
                                }} />
                        </Column>
                        <Column className="colour-name-container" showOnlyFor="small">
                            {selectedColour.name}
                        </Column>
                        <Column
                            pullOnLarge={7}
                            large={5}
                            className="swatch-selector-container">
                            <Row isColumn>
                                <Field name="WindowColourId" component={SelectColour} colours={colours} />
                            </Row>
                            <Row isColumn>
                                <Field
                                    name="WindowColourInterior"
                                    component={SwitchInput}
                                    disabled={!hasWhiteInterior}>
                                    White interior frame
                                    <Popup component={WhiteInteriorPopup}>
                                        <span className="info-icon">i</span>
                                    </Popup>
                                </Field>
                            </Row>
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("WindowWizard");
    let windowStyleId = valueSelector(state, "WindowStyleId") || 1;
    let windowRoomId = valueSelector(state, "WindowRoomId") || 21;
    let windowColourId = valueSelector(state, "WindowColourId");
    let windowColourInterior = valueSelector(state, "WindowColourInterior");

    let colours = getMainWindowColours(state);

    let selectedColour = colours.filter(c => c.id === windowColourId)[0] || {};
    let hasWhiteInterior = selectedColour.relatedColourId !== 0;

    let selectedStyle = utils.getValueById(state.Window.Styles, windowStyleId);

    let defaultColourId = selectedStyle.defaultColourId;

    if (!defaultColourId && colours.length > 0) {
        defaultColourId = colours[0].id;
    }

    return {
        colours,
        selectedColour,
        windowStyleId,
        windowColourInterior,
        hasWhiteInterior,
        defaultColourId,
        windowRoomId,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { getWindowOptions, updatePreviousSelection })(ColourForm);



// WEBPACK FOOTER //
// ./src/containers/WindowForm/ColourForm.js